module.exports = __webpack_public_path__ + "img/ico-dash.a117f3e1.svg";